import Cookies from "js-cookie";
import React from "react";
import { Navigate } from "react-router-dom";
import { isLoggedIn } from "./utils/apiHandlers";

const DaoPrivateRoue = ({ children }) => {
  const isLogin = isLoggedIn();
  return localStorage.getItem("daoWalletAddress") ? (
    children
  ) : isLogin ? (
    <Navigate to="/portal/dao/login" />
  ) : (
    <Navigate to="/portal" />
  );
};

export default DaoPrivateRoue;
